import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import AccessibilityButton from "../../ui/default/common/AccessibilityButton";

const Styled = {
  SkipAheadButton: styled(AccessibilityButton)`
    position: absolute;
    top: 10px;
    left: 150px;
    padding: 8px;
  `,
};

export interface SkipAheadButtonProps {
  captionId: string;
  action: () => void;
}

const SkipAheadButton: React.FC<SkipAheadButtonProps> = ({
  captionId,
  action,
}) => {
  return (
    <Styled.SkipAheadButton onClick={action}>
      <FormattedMessage id={captionId} />
    </Styled.SkipAheadButton>
  );
};

export default SkipAheadButton;
